<div class="option-picker">
  <div class="custom-filter-group">
    <p class="custom-label" [id]="titleId">{{ title }}</p>
    <div class="radio-options" role="radiogroup" [attr.aria-labelledby]="titleId">
      @for (option of options; track option.value) {
      <button
        type="button"
        role="radio"
        class="custom-radio"
        [class.selected]="selectedValue === option.value"
        [attr.aria-checked]="selectedValue === option.value"
        (click)="selectOption(option.value)"
      >
        <span class="circle" aria-hidden="true"></span>
        {{ option.label }}
      </button>
      }
    </div>
  </div>
</div>
